import React from "react";


const Card = ({ list, current, handleonClick }) => {

  return list.map((item, index) => {
    return (
      <div  key={item._id}>
        <div className="row">
          {item && current === item._id ? (
            <div
              style={{ width: 50, height: 30, fontSize: "14px" }}
              className="col-xs-1   bg-primary border border-muted text-light  border-bottom-0 border-right-0"
            >
              <div className="d-flex justify-content-center">
                {item.queuetime}
                {":00"}
              </div>
            </div>
          ) : (
            <div
              style={{ width: 50, height: 30, fontSize: "14px" }}
              className="col-xs-1  bg-secondary border border-muted text-light  border-bottom-0 border-right-0"
            >
              <div className="d-flex justify-content-center
          ">
                {item.queuetime}
                {":00"}
              </div>
            </div>
          )}

          {item &&
            item.queue &&
            item.queue.length > 0 &&
            item.queue.map((queue, index) => {
              return (
               
                  <div key={index}
                    style={{ width: 100, maxHeight: 40, fontSize: "12px" }}
                    className="m-1  shadow "
                  >
                    <div className="d-flex justify-content-center
          ">
                      { queue.statusid ===1 ?<span
                        className="badge bg-info text-dark "
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                     
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span>: queue.statusid ===2 ? <span
                        className="badge bg-success"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                      
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span> :queue.statusid ===3 ? <span
                        className="badge badge text-dark"
          
                        style={{
                          fontSize: "13px",
                          backgroundColor: "#42f58d",cursor: "pointer"
                        }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                      
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span> : queue.statusid ===4 ? <span
                        className="badge badge text-dark"
          
                        style={{
                          fontSize: "13px",
                          backgroundColor: "#fcf003",cursor: "pointer"
                        }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                      
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span> : queue.statusid ===5 ? <span
                        className="badge badge text-dark"
          
                        style={{
                          fontSize: "13px",
                          backgroundColor: "#fc6b03",cursor: "pointer"
                        }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                      
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span> : <span
                        className="badge badge text-dark"
          
                        style={{
                          fontSize: "13px",
                          backgroundColor: "#fc0b03",cursor: "pointer"
                        }}
                        onClick={() =>
                          handleonClick(queue.weight_no)
                                      }
                      >                       
                        {queue.first_driven_no}   {queue.first_driven_prov} 
                      </span> }
                    </div>
                  </div>
            
              );
            })}            
        </div>
      </div>
    );
  });
};

export default Card;
